{
  "Account not linked": "Compte non relié",
  "Actions": "Actions",
  "Activity reports": "Comptes rendus",
  "All people": "Toutes les personnes",
  "All projects": "Tous les projets",
  "All streams": "Tous les streams",
  "All submitted reports, by week. Search their text or filter by period, project, stream and person.": "Tous les comptes rendus soumis, par semaine. Recherchez dans leur texte ou filtrez par période, projet, stream et personne.",
  "Authentication unavailable": "Authentification indisponible",
  "Awaiting the DAR": "En attente de la DAR",
  "Back to projects": "Retour aux projets",
  "Cancel": "Annuler",
  "Cancel the request": "Annuler la demande",
  "Cancel this request?": "Annuler cette demande ?",
  "Clear": "Effacer",
  "DAR's answer": "Réponse de la DAR",
  "Date": "Date",
  "Draft saved": "Brouillon enregistré",
  "Due before <strong>{{deadline}}</strong>.": "À rendre avant le <strong>{{deadline}}</strong>.",
  "Effective date: {{date}}": "Date d'effet : {{date}}",
  "Fill in at least one section.": "Renseignez au moins une section.",
  "Fill in “Done” or tick “Absent / no activity”.": "Renseignez « Réalisé » ou cochez « Absent / pas d'activité ».",
  "Filter reports": "Filtrer les comptes rendus",
  "From the start": "Depuis le début",
  "From week": "Depuis la semaine",
  "Full-text search does not filter by stream: the stream filter is ignored.": "La recherche plein texte ne filtre pas par stream : le filtre stream est ignoré.",
  "Git identities (emails or author names)": "Identités Git (emails ou noms d'auteur)",
  "Git identities saved": "Identités Git enregistrées",
  "Guidelines": "Consignes",
  "Keep the request": "Garder la demande",
  "Loading reports…": "Chargement des comptes rendus…",
  "Loading the week…": "Chargement de la semaine…",
  "Loading your requests…": "Chargement de vos demandes…",
  "My Git identities": "Mes identités Git",
  "My activity report": "Mon compte rendu d'activité",
  "My message": "Mon message",
  "My recent weeks": "Mes dernières semaines",
  "My requests": "Mes demandes",
  "My space": "Mon espace",
  "Next week ›": "Semaine suivante ›",
  "No overdue reports.": "Aucun CRA en retard.",
  "No report expected this week": "Aucun CRA attendu cette semaine",
  "No reports": "Aucun compte rendu",
  "No reports yet.": "Pas encore de CRA.",
  "No requests": "Aucune demande",
  "No results": "Aucun résultat",
  "Nothing matches these criteria.": "Rien ne correspond à ces critères.",
  "Nothing to save": "Rien à enregistrer",
  "One report per week, one section per project. Drafts are visible only to you; a submitted report can be read by everyone.": "Un CRA par semaine, une section par projet. Les brouillons ne sont visibles que de vous ; un CRA soumis est lisible par tous.",
  "Only you can see it until it is submitted.": "Il n'est visible que de vous tant qu'il n'est pas soumis.",
  "Optional": "Facultatif",
  "Overdue": "En retard",
  "Page not found": "Page introuvable",
  "Person": "Personne",
  "Project": "Projet",
  "Ranked by relevance, grouped by week.": "Classés par pertinence, regroupés par semaine.",
  "Report submitted": "CRA soumis",
  "Report updated": "CRA mis à jour",
  "Report week": "Semaine du CRA",
  "Report {{week}}": "CRA {{week}}",
  "Reports are only required from week {{week}} onwards: this one is optional.": "Les CRA ne sont demandés qu'à partir de la semaine {{week}} : celui-ci est facultatif.",
  "Request": "Demande",
  "Request cancelled": "Demande annulée",
  "Save": "Enregistrer",
  "Save changes": "Enregistrer les modifications",
  "Save draft": "Enregistrer le brouillon",
  "Search reports": "Rechercher dans les comptes rendus",
  "Search reports (full text)…": "Rechercher dans les CRA (plein texte)…",
  "See projects": "Voir les projets",
  "Show more": "Afficher plus",
  "Sign out": "Se déconnecter",
  "Signed-in account: <strong>{{email}}</strong>. The resource allocation office can link it to your record (Administration › People › Unlinked accounts).": "Compte connecté : <strong>{{email}}</strong>. La direction de l'allocation des ressources peut le relier à votre fiche (Administration › Personnes › Comptes non reliés).",
  "Some changes are not saved. Change week anyway?": "Des modifications ne sont pas enregistrées. Changer de semaine quand même ?",
  "Status": "Statut",
  "Stream": "Stream",
  "Stream “{{stream}}”": "Stream « {{stream}} »",
  "Submit": "Soumettre",
  "Submitted": "Soumis",
  "Submitted reports will appear here.": "Les comptes rendus soumis apparaîtront ici.",
  "Team reports": "CRA de l'équipe",
  "The authentication server is not responding (<code>{{url}}</code>). Try again in a moment; if the problem persists, let the ada team know.": "Le serveur d'authentification ne répond pas (<code>{{url}}</code>). Réessayez dans un instant ; si le problème persiste, prévenez l'équipe ada.",
  "The authors of your commits, to draft the report from Git with Claude.": "Les auteurs de vos commits, pour rédiger le CRA depuis Git avec Claude.",
  "The start week is after the end week.": "La semaine de début est postérieure à la semaine de fin.",
  "This address matches no ada screen.": "Cette adresse ne correspond à aucun écran d'ada.",
  "This report is submitted: your changes will be visible to everyone.": "Ce CRA est soumis : vos modifications seront visibles de tous.",
  "This screen could not be displayed": "Cet écran n'a pas pu s'afficher",
  "This week has not started yet: a report cannot be filed for a future week.": "Cette semaine n'est pas encore commencée : on ne rend pas le CRA d'une semaine future.",
  "To file": "À rendre",
  "To join a project, open its page and click “Ask to join”.": "Pour rejoindre un projet, ouvrez sa fiche et cliquez sur « Demander à rejoindre ».",
  "Try again": "Réessayer",
  "Unexpected error": "Erreur inattendue",
  "Unreadable week “{{week}}”: showing the default week.": "Semaine illisible « {{week}} » : affichage de la semaine par défaut.",
  "Unsaved changes": "Modifications non enregistrées",
  "Up to today": "Jusqu'à aujourd'hui",
  "Up to week": "Jusqu'à la semaine",
  "Whole project": "Tout le projet",
  "You were not assigned to any project that week.": "Vous n'étiez affecté(e) à aucun projet cette semaine-là.",
  "Your Boond email ({{email}}) is always included.": "Votre email Boond ({{email}}) est toujours pris en compte.",
  "Your account is not linked to any Boond person, contact the DAR.": "Votre compte n'est relié à aucune personne Boond, contactez la DAR.",
  "Your request to {{action}} {{project}} will be withdrawn.": "Votre demande pour {{action}} {{project}} sera retirée.",
  "Your requests to join or leave a project, and the DAR's answer.": "Vos demandes pour rejoindre ou quitter un projet, et la réponse de la DAR.",
  "first.last@example.com, Enter to add": "prenom.nom@exemple.com, Entrée pour ajouter",
  "the request on {{project}}": "la demande sur {{project}}",
  "{{count}} activity reports_one": "{{count}} compte rendu",
  "{{count}} activity reports_other": "{{count}} comptes rendus",
  "{{count}} linked repositories_one": "{{count}} dépôt lié",
  "{{count}} linked repositories_other": "{{count}} dépôts liés",
  "{{count}} results_one": "{{count}} résultat",
  "{{count}} results_other": "{{count}} résultats",
  "{{count}} sections still to file for this week._one": "Il reste {{count}} section à rendre pour cette semaine.",
  "{{count}} sections still to file for this week._other": "Il reste {{count}} sections à rendre pour cette semaine.",
  "{{count}} streams: {{list}}_one": "{{count}} stream : {{list}}",
  "{{count}} streams: {{list}}_other": "{{count}} streams : {{list}}",
  "{{message}}. Reload the page: a new version of ada may have been deployed.": "{{message}}. Rechargez la page : une nouvelle version d'ada a peut-être été déployée.",
  "{{title}} (archived)": "{{title}} (archivé)",
  "{{title}} (closed)": "{{title}} (clos)",
  "{{title}} (paused)": "{{title}} (en pause)",
  "{{week}}: complete.": "{{week}} : complet.",
  "‹ Previous week": "‹ Semaine précédente"
}
